module.exports = __webpack_public_path__ + "media/images/teams/GENOA-9ef082e3cd6139574ce5f2f6b75a4cfe.png";